export const BreakPoints = {
  smMin: 320,
  mdMin: 768,
  lgMin: 1024
}
